export default __webpack_public_path__ + "static/media/roboto-v20-latin-900.117624e9.svg";